<div class="container-fluid">
    <div>
        <div class="d-flex m-3">
            <div class="mr-2">
                <button mat-icon-button (click)="back()">
                    <mat-icon style="color: #00FF00" svgIcon="feather:arrow-left-circle"></mat-icon>
                </button>
            </div>
            <h2 class="h3 createHeading">{{ title }}:&nbsp;{{branchName}}</h2>
        </div>

        <div class="card m-2" style="border: none;overflow-y: auto;">
            <div class="card-header" style="border: none ;">
                <h4>
                    Branch Off Peak Timings
                    <span class="text-danger">*</span>
                </h4>
            </div>
            
            <div class="card-body">
                <div class="row justify-content-around" style="max-height:450px;">
                    <div class="col-sm-12 col-md-4">
                        <div class="d-flex flex-column align-items-center">
                            <div style="width: 60%">
                                <div class="fw-bold fieldName">Select Day</div>
                                <div class="">
                                    <div class="">
                                        <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 100%">
                                            <mat-select [placeholder]="'ALL'"
                                                (selectionChange)="selectedDays($event.value)" [(ngModel)]="days"
                                                multiple>
                                                <mat-checkbox class="" [checked]="allComplete"
                                                    [indeterminate]="someComplete()" (change)="setAll($event)">
                                                    Select All
                                                </mat-checkbox>

                                                <mat-option *ngFor="let day of daysList" [value]="day.value">
                                                    {{ day.viewValue }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 60%" *ngIf="false">
                                <div class="fw-bold fieldName">
                                    Select Day Type
                                </div>
                                <div class="">
                                    <div class="">
                                        <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 100%">
                                            <mat-select [placeholder]="'ALL'" [disabled]="days.length <= 0"
                                                (selectionChange)="selectedDayType($event.value)" [(ngModel)]="daysType">
                                                <mat-option *ngFor="let day of dayType" [value]="day.value">
                                                    {{ day.viewValue }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 60%">
                                <div class="fw-bold fieldName">Start Time</div>
                                <div class="">
                                    <div class="">
                                        <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 100%">
                                            <input matInput class="cursor-pointer" [disabled]="disableTime" mode="12h"
                                                [placeholder]="'Select Start Time'" [(ngModel)]="startTime" matTimepicker>
                                            <mat-icon svgIcon="mat_outline:access_time"></mat-icon>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 60%">
                                <div class="fw-bold fieldName">End Time</div>
                                <div class="">
                                    <div class="">
                                        <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 100%">
                                            <input class="cursor-pointer" matInput [placeholder]="'Select End Time'" 
                                            mode="12h" 
                                            [disabled]="disableTime || !startTime" 
                                            [minDate]="startTime" 
                                            [(ngModel)]="endTime" 
                                            matTimepicker 
                                            />
                                            <mat-icon svgIcon="mat_outline:access_time"></mat-icon>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 60%">
                                <div class="fw-bold fieldName">Pro Rata Percentage</div>
                                <div class="">
                                    <div class="">
                                        <mat-form-field class="flex-auto gt-xs:pr-3" style="width: 100%">
                                            <input id="proRataPercentageField" class="bg-white" placeholder="Enter Percentage" matInput
                                                name="proRataPercentageField"
                                                #proRataPercentageField="ngModel"
                                                type="number"
                                                min="0.01"
                                                required
                                                [disabled]="!endTime" 
                                                [(ngModel)]="proRataPercentage"
                                                (ngModelChange)="updatePeakTimingAddableOrNot()"
                                                 />
                                                <mat-error *ngIf="proRataPercentageField.invalid && proRataPercentageField.touched && proRataPercentageField.errors.required">
                                                    Percentage is required
                                                </mat-error>
                                                <mat-error *ngIf="proRataPercentageField.invalid && proRataPercentageField.touched && proRataPercentageField.errors.min">
                                                    Percentage should be greater than 0.01
                                                </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end" *ngIf="showErrorMsgToAddTimeSlots">
                            <span class="text-danger">{{errorMsgToAddTimeSlots}}</span>
                        </div>
                        <div class="d-flex mt-3 mb-3" style="float: right">
                            <button class="ml-4 addTimeBtn" mat-flat-button [color]="'primary'"
                                [ngClass]="{ 'btn-clr': !disableAdd }"
                                [disabled]="disableAdd"
                                (click)="addTimeSlots()"
                                >
                                <span class="ml-2 mr-1 txt" style="color: white">Add</span>
                            </button>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 d-flex flex-column align-items-center"
                        style="max-height:450px; overflow-y:scroll;">
                        <table class="table" style="width: 90%">
                            <thead class="thead-dark"
                                style="background: #000; color: #fff;  position: sticky; top: 0; z-index: 1;">
                                <tr>
                                    <th scope="col">Days</th>
                                    <th scope="col">Timing Type</th>
                                    <th scope="col">Start Time</th>
                                    <th scope="col">End Time</th>
                                    <th scope="col">Pro Rata Percentage</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let slot of sortedTimeSlots;">
                                    <th scope="row">{{ slot.day }}</th>
                                    <th class="">Off Peak Time</th>
                                    <th>{{ slot.startTime }}</th>
                                    <th>{{ slot.endTime }}</th>
                                    <th>{{ slot.pro_rata_percentage }}</th>
                                    <td>
                                        <button mat-icon-button (click)="deleteDay(slot)">
                                            <mat-icon style="color: red" svgIcon="mat_outline:delete"></mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="">
        <div class="bottomBtns mb-3 row">
            <button class="ml-4 addBtn" mat-flat-button (click)="resetForm()" *ngIf="!isUpdate">
                <span class="ml-2 mr-1 txt">Reset</span>
            </button>
            <button class="ml-4 addBtn" mat-flat-button (click)="back()" *ngIf="isUpdate">
                <span class="ml-2 mr-1 txt">Cancel</span>
            </button>
            <span matTooltip="userTimings should be added for all the seven days" *ngIf="!isUpdate"
                [matTooltipDisabled]="isCreateOrUpdatebranchValid()" style="width: fit-content"></span>
            <button *ngIf="!isUpdate" class="ml-4 mr-6 addBtn" mat-flat-button [color]="'primary'"
                [ngClass]="{ 'btn-clr': isCreateOrUpdatebranchValid() }"
                [disabled]="!isCreateOrUpdatebranchValid()" 
                (click)="createOrUpdateBranch()"
                >
                <span class="ml-2 mr-1 txt" style="color: black">Create </span>
            </button>
            <button *ngIf="isUpdate" class="ml-4 mr-6 addBtn" mat-flat-button [color]="'primary'" 
                [ngClass]="{ 'btn-clr': isCreateOrUpdatebranchValid() }"
                [disabled]="!isCreateOrUpdatebranchValid()" 
                (click)="createOrUpdateBranch()"
                >
                <span class="ml-2 mr-1 txt" style="color: black">Update </span>
            </button>
            <!-- <button class="ml-4 mr-6 addBtn" mat-flat-button [color]="'primary'" 
            [disabled]="!basicDetailsForm.valid || !adddressForm.valid || disableCreate" (click)="createBranch()"
               >
                <span class="ml-2 mr-1 txt">Create </span>
            </button> -->
        </div>
    </div>
</div>